var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_1388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6284 8.01199C13.926 8.01199 12.4047 8.89437 12.4047 10.5246C12.4047 12.3942 15.1029 12.5234 15.1029 13.4626C15.1029 13.8581 14.6496 14.2121 13.8756 14.2121C12.777 14.2121 11.956 13.7174 11.956 13.7174L11.6046 15.3626C11.6046 15.3626 12.5505 15.7804 13.8063 15.7804C15.6675 15.7804 17.1321 14.8547 17.1321 13.1966C17.1321 11.221 14.4227 11.0957 14.4227 10.2239C14.4227 9.91411 14.7948 9.57467 15.5666 9.57467C16.4375 9.57467 17.148 9.93442 17.148 9.93442L17.4918 8.34551C17.4918 8.34551 16.7187 8.01199 15.6284 8.01199V8.01199ZM0.053215 8.13191L0.0119934 8.37175C0.0119934 8.37175 0.728192 8.50282 1.37324 8.76429C2.2038 9.06411 2.26297 9.23866 2.40285 9.78078L3.92711 15.6567H5.97039L9.11823 8.13191H7.07963L5.05696 13.2481L4.23159 8.91137C4.1559 8.41504 3.77248 8.13191 3.30317 8.13191H0.053215V8.13191ZM9.93798 8.13191L8.33876 15.6567H10.2827L11.8763 8.13191H9.93798V8.13191ZM20.7802 8.13191C20.3114 8.13191 20.0631 8.38288 19.8808 8.82144L17.0328 15.6567H19.0714L19.4658 14.5175H21.9494L22.1892 15.6567H23.988L22.4188 8.13191H20.7802V8.13191ZM21.0453 10.1649L21.6496 12.9886H20.0307L21.0453 10.1649V10.1649Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_1388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 7.7924,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card_visa.4c201e16989ff71096475cb0c2aa4178.svg";
export { ForwardRef as ReactComponent };